export const documentation = {
  junior: [
    { name: 'Product Requirements Document Template', url: '/docs/prd-template', type: 'templates' },
    { name: 'User Story Writing Guidelines', url: '/docs/user-story-guidelines', type: 'requirements' },
    { name: 'Product Roadmap Process', url: '/docs/roadmap-process', type: 'planning' },
    { name: 'Sprint Planning for Product Managers', url: '/docs/sprint-planning-pm', type: 'agile' },
    { name: 'Stakeholder Communication Guide', url: '/docs/stakeholder-communication', type: 'communication' }
  ],
  mid: [
    { name: 'Product Strategy Framework', url: '/docs/product-strategy-framework', type: 'strategy' },
    { name: 'Market Research Guidelines', url: '/docs/market-research', type: 'research' },
    { name: 'Competitive Analysis Process', url: '/docs/competitive-analysis', type: 'analysis' },
    { name: 'Product Metrics and KPIs', url: '/docs/product-metrics', type: 'analytics' },
    { name: 'Go-to-Market Strategy', url: '/docs/gtm-strategy', type: 'launch' }
  ],
  senior: [
    { name: 'Product Vision and Strategy', url: '/docs/product-vision-strategy', type: 'vision' },
    { name: 'Portfolio Management Framework', url: '/docs/portfolio-management', type: 'portfolio' },
    { name: 'Product Leadership Guidelines', url: '/docs/product-leadership', type: 'leadership' },
    { name: 'Innovation Process Framework', url: '/docs/innovation-process', type: 'innovation' },
    { name: 'Executive Communication Guide', url: '/docs/executive-communication', type: 'executive' }
  ]
};
